// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomNav__eQV","navItem":"navItem_OZhY","icon":"icon_YBOB","label":"label_d2Ld"};